module.exports = __webpack_public_path__ + "img/logo20.288794e8.jpg";